<div class="form-group">
  @if (showLabel && question?.email_version) {
    <label class="form-group__label" [innerHtml]="question?.email_version"></label>
  }
  @if (showSkip) {
    <div class="question-skip">
      <label class="selection">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <div class="selection__inner">
            <div class="selection__main">
              <div class="selection__left">
                <div class="selection__switch"></div>
              </div>
              <div class="selection__content">
                <div class="selection__label">
                  <div class="selection__title">Skip for now</div>
                </div>
              </div>
            </div>
          </div>
        </label>
      </div>
    }


    @for (option of items; track option; let i = $index) {
      <label class="tile" [ngClass]="{'disable-readonly': readOnly}">
        <input type="radio" [checked]="(option.answer == question.answer) || (question.answer == 'Multiple answers')"
          (click)="checkRadio(option)" [disabled]="readOnly || skipped" [attr.data-answer]="option.answer"
          [name]="uniqueControlName">
          <div class="tile__inner">
            <div class="tile__main">
              <div class="tile__content">
                <div class="tile__indi"><span></span></div>
                <div class="tile__label">
                  <div class="tile__title">{{option?.answer}}</div>
                </div>
              </div>
            </div>
          </div>
        </label>
      }

      @if (additionalQuestion) {
        <hr class="hr--xs" />
      }
      @if (additionalQuestion) {
        <div  class="form-group">
          @for (item of questions; track item; let i = $index) {
            <app-question-controller
              [question]="item"
              [showLabel]="true"
              (questionAnswer)="onChange($event, i)"
              >
            </app-question-controller>
          }
        </div>
      }
    </div>



